export default __webpack_public_path__ + "static/media/navbrand.713192c7.png";